/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { getMenuParentElements, menuHasChildren } from "../../menuHelpers";

const DesktopMainMenu = (props) => {
  const { 
    sitemegamenu, 
    activeMenu, 
    setActiveMenu, 
    sitemegamenumuotolevy,
    onMouseEnter,
    onMouseLeave 
  } = props;
  
  const parentMenu = getMenuParentElements(
    sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
  );
  
  if (!parentMenu) return null;
  
  return (
    <ul className="flex items-center justify-between m-0" onMouseLeave={onMouseLeave}>
      {parentMenu.map((item) => {
        const hasChildren = menuHasChildren(
          sitemegamenu.concat(sitemegamenumuotolevy), // NOTE: concat megamenu and muotolevy-menu
          item.ID,
        );
        
        if (!hasChildren) {
          return (
            <li key={item.ID} className="list-none transition-all duration-200 px-4 py-4 mx-1 hover:bg-white/10">
              <a 
                href={item.url} 
                className="text-base text-white hover:text-white hover:no-underline"
              >
                {item.title}
              </a>
            </li>
          );
        }
        
        const isActive = activeMenu && activeMenu.ID === item.ID;
        
        return (
          <li 
            key={item.ID}
            onMouseEnter={() => onMouseEnter(item)}
            className="list-none transition-all duration-200 px-4 py-4 mx-1 hover:bg-white/10"
          >
            <a
              role="button"
              onClick={(e) => {
                e.preventDefault();
                // Click toggles menu (for touch devices or as fallback)
                if (activeMenu && activeMenu.ID === item.ID) {
                  setActiveMenu(null);
                } else {
                  setActiveMenu(item);
                }
              }}
              className={`text-base text-white hover:text-white hover:no-underline cursor-pointer ${isActive ? 'font-bold' : ''}`}
            >
              {item.title}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default DesktopMainMenu;